export enum CustomStrategyStatus {
  /** 신규 */
  NEW = "NEW",
  /** 연락중 */
  CONTACTING = "CONTACTING",
  /** 상담완료 */
  CONSULTED = "CONSULTED",
  /** 물건추천 */
  RECOMMENDED = "RECOMMENDED",
  /** 계약 */
  CONTRACT = "CONTRACT",
  /** 종료 */
  CLOSED = "CLOSED",
}

export const CUSTOM_STRATEGY_STATUS_LABEL: Record<CustomStrategyStatus, string> = {
  [CustomStrategyStatus.NEW]: "신규",
  [CustomStrategyStatus.CONTACTING]: "연락중",
  [CustomStrategyStatus.CONSULTED]: "상담완료",
  [CustomStrategyStatus.RECOMMENDED]: "물건추천",
  [CustomStrategyStatus.CONTRACT]: "계약",
  [CustomStrategyStatus.CLOSED]: "종료",
};

export const CUSTOM_STRATEGY_STATUS_COLOR: Record<CustomStrategyStatus, string> = {
  [CustomStrategyStatus.NEW]: "#3b82f6",
  [CustomStrategyStatus.CONTACTING]: "#f97316",
  [CustomStrategyStatus.CONSULTED]: "#14b8a6",
  [CustomStrategyStatus.RECOMMENDED]: "#a855f7",
  [CustomStrategyStatus.CONTRACT]: "#22c55e",
  [CustomStrategyStatus.CLOSED]: "#6b7280",
};
